export default __webpack_public_path__ + "static/media/PPI-steps-012.8c168cf7.jpg";